<div class="solo-stat" [ngStyle]="boxStyles() | theme">
  <div [ngStyle]="labelStyles() | theme">{{ label() }}</div>
  <ng-content />
</div>
